import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TimeSlot} from 'src/app/store/entities';

// Path: src/app/components/buttons/button/button.component.ts
@Component({
  selector: 'mwo-edit-day-schedule-item',
  templateUrl: './edit-day-schedule-item.component.html',
  styleUrls: ['./edit-day-schedule-item.component.scss'],
})
export class EditDayScheduleItemComponent {

  @Output() onEdit = new EventEmitter();
  @Output() onDelete = new EventEmitter();

  constructor() {
  }

  private _timeSlot: TimeSlot;

  get timeSlot(): TimeSlot {
    return this._timeSlot;
  }

  @Input()
  set timeSlot(value: TimeSlot) {
    this._timeSlot = value;
  }

  private _activeEdit: boolean;

  get activeEdit(): boolean {
    return this._activeEdit;
  }

  @Input()
  set activeEdit(value: boolean) {
    this._activeEdit = value;
  }

  private _disableDelete: boolean;

  get disableDelete(): boolean {
    return this._disableDelete;
  }

  @Input()
  set disableDelete(value: boolean) {
    this._disableDelete = value;
  }

  get name(): string {
    if (this.slotHasPlaylist()) {
      return this.timeSlot.event.name;
    }
    if (this.slotHasPlayrule()) {
      return this.timeSlot.tempo.name;
    } else {
      return '';
    }
  }

  slotHasPlaylist(): boolean {
    return this.timeSlot.event != undefined && this.timeSlot.tempo == undefined;
  }

  slotHasPlayrule(): boolean {
    return this.timeSlot.tempo != undefined && this.timeSlot.event == undefined;
  }

  slotHasNoPlaylistNorPlayrule(): boolean {
    return this.timeSlot.tempo == undefined && this.timeSlot.event == undefined;
  }

  handleEdit() {
    this.onEdit.emit();
  }

  handleDelete() {
    this.onDelete.emit();
  }

  hexToRgb(hex: string): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
  }

  getGradientStyle(): string {
    let color = '';

    if (this.timeSlot) {
      if (this.slotHasPlaylist()) {
        color = this.timeSlot.event.color;
      } else if (this.slotHasPlayrule()) {
        color = this.timeSlot.tempo.color;
      }
    }

    // Si aucune couleur n'est définie, couleur blanche
    if (!color) {
      color = '#FFFFFF';
    }

    const rgbColor = this.hexToRgb(color);
    return `linear-gradient(rgba(${rgbColor}, 0.1), rgba(${rgbColor}, 0.1))`;
  }
}
